// src/lib/mso-canonical.ts
//
// Deterministic JSON for COMPARING two parts of a rule definition in the browser: object keys
// sorted at every depth, array order kept. ⚠ This is for the diff view only. The definition
// HASH that test evidence is bound to is computed on the server (`packages/rules`), and this
// file never computes or compares one: whether a test run still covers a draft is read from
// the run's `definitionHash` against the version's own, both server-supplied.
export function canonicalText(value: unknown): string {
  if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null'
  if (Array.isArray(value)) return `[${value.map(canonicalText).join(',')}]`
  const entries = Object.entries(value as Record<string, unknown>)
    .filter(([, v]) => v !== undefined)
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
  return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonicalText(v)}`).join(',')}}`
}
